import type { IntakeRoute } from '../../types/notifications';

export function routeLabel(route: IntakeRoute): string {
  const labels: Record<IntakeRoute, string> = {
    epic: 'Epic',
    feature: 'Feature',
    bug: 'Bug',
    'design-system': 'Design System',
    prototype: 'Prototype',
  };
  return labels[route] ?? route;
}

export function formatRelativeTime(isoString: string): string {
  const diff = Date.now() - new Date(isoString).getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
}
